export default function round(number, decimals = 0) {
	const factor = Math.pow(10, decimals);

	return Math.round(number * factor) / factor;
}
